export default "__VITE_ASSET__nKfsGni7__"